import React, {useEffect, useState} from 'react';
import PageHeader from "../../new-components/admin/page-header";
import TextareaEdit from '../../new-components/admin/fields/textarea-edit'
import InputEdit from '../../new-components/admin/fields/input-edit'
import MediaManager from "../../components/MediaManager";

//helpers
import {replaceAll, capitalizeFirstLetter} from "../../helpers";
//api
import {apiGetAllFields} from "../../api/public";
//constants
import {aboutAcf, contactFormAcf } from "../../constants/acf";

const typeField = field => {
    switch (field) {
        case 'intro-description':
            return TextareaEdit;
        case 'contact-form-description':
            return TextareaEdit;
        default:
            return InputEdit;
    }
}
const replaceAndCapitalize = (str, find, replace) => capitalizeFirstLetter(replaceAll(str, find, replace));

const styleContainer = {
    display: 'grid',
    gap: '25px',
}
const EditAboutPage = () => {

    const [aboutFields, setAboutFields] = useState([]);
    const [contactFormFields, setContactFormFields] = useState([]);

    useEffect(() => {
        let abort = false;
        apiGetAllFields(aboutAcf)
            .then(fields =>  {
                if(!abort) setAboutFields(fields)
            });
        apiGetAllFields(contactFormAcf)
            .then(fields =>  {
                if(!abort) setContactFormFields(fields)
            });
        return () => { abort = true };
    }, [])
    return (
        <div className="admin-container main-container" style={styleContainer}>
            <PageHeader title="About Us Content"/>
            {aboutFields.map(field => {
                const ComponentField = typeField(field.type);
                return <ComponentField
                    key={field.type}
                    label={replaceAndCapitalize(field.type, '-', ' ')}
                    initValue={field.valueStr}
                    name={field.type}
                    cols="50"
                    rows="5"
                />
            })}
            <div>
                <h2>Contact Form</h2>
                {contactFormFields.map(field => {
                    const ComponentField = typeField(field.type);
                    return <ComponentField
                        key={field.type}
                        label={replaceAndCapitalize(field.type, '-', ' ')}
                        initValue={field.valueStr}
                        name={field.type}
                        cols="50"
                        rows="5"
                    />
                })}
            </div>
            <MediaManager type="about-us-slider" title="About Us Slider" />
        </div>
    );
}

export default EditAboutPage;



// WEBPACK FOOTER //
// ./src/page/admin/edit-about-page.js